






































































































































































































































































































































































































































/* eslint-disable @typescript-eslint/camelcase */
import GoogleMap from "../components/GoogleMap.vue";
import { Component, Mixins, Watch } from "vue-property-decorator";
import { LocationService } from "../service/location.service";
import Swal from "sweetalert2";
import { ContentService } from "@/service/content.service";
import { LocationsContent } from "@/models/content/locations";
import CommonMixin from "@/mixins/common-mixins";
import PageLoader from "@/components/PageLoader.vue"
import { ZipCode } from "@/models/zipcode";
import { ZipCodeService } from "@/service/zipcode.service";
import { Address } from "@/models/address";
import { text } from "@fortawesome/fontawesome-svg-core";
import { relativeTimeRounding } from "moment";

@Component({
  components: {
    GoogleMap,
    PageLoader
  },
  validations: {
    addressSuggestion: {
      validAddress(address: string) {
        if (address === "") {
          return true;
        }
        const model = (this as unknown) as GoogleMappers;
        return model.addressIsComplete
      }, 
       validCounty(address: string) {
        if (address === "") {
          return true;
        }
        const model = (this as unknown) as GoogleMappers;
        return model.addressIsComplete && model.validCounty
      }, 
    },
  },
})
export default class GoogleMappers extends Mixins(CommonMixin) {
  //TODO: Save filtered address locations so if user uses same address with different filter selections
  // a seperate api call does not need to be made.

  /* eslint-disable  @typescript-eslint/no-explicit-any */
  sliderDefault = 0;
  radiusDefault = 5;
  addressInput = "";
  addressLat: null | number = null;
  addressLng: null | number = null;
  validCounty = false;
  numMiles = 5;
  addressSuggestion = this.addressInput;
  earlyheadstartChecked = false;
  headstartChecked = false;
  greatstartChecked = false;
  cooperativeChecked = false;
  miChildDevChecked = false;
  sliderStarRating = this.sliderDefault;
  sliderRadius = this.radiusDefault;
  miChildDev = false;
  mapData = {} as { [key: string]: any[] | string | number | null };
  mapLocations = {};
  // The watcher on GoogleMap.vue does not detect if a innner obect value is modified.
  // Therefor integer that will be incremented will be used within the watcher.
  // When the locations are updated increment updatedData;
  updatedData = 0;
  locationContent: LocationsContent = {} as LocationsContent;
  hideFilterMenu = true;
  modalHeader = "";
  modalBody = "";
  modalLearnMoreLink = "";
  locationsAll: object[] = [];
  center = { lat: 42.355, lng: -83.15 };
  client: string | (string | null)[] = this.$route?.query?.client;
  isDHS = this.client === "isDHS";
  textDirection = "ltr";
  dynamicFindLocationsProxy = "";
  showPageLoader = true
  zipCodeData: Array<ZipCode>  = []
  addressComponents = {} as Address;
  addressIsComplete = true

  //https://local.connect4carekids.org:8080/Locations?filter=hs&client=dhs
  // TODO: limit to detroit area:
  // var cityBounds = new google.maps.LatLngBounds(
  // new google.maps.LatLng(25.341233, 68.289986),
  // new google.maps.LatLng(25.450715, 68.428345));
  async mounted(): Promise<void> {
    const contentService = new ContentService(this.$route);
    const  zipcodeService = new ZipCodeService();

    this.locationContent = await contentService.getLocationsContent();
    this.zipCodeData = await zipcodeService.GetActiveZipCodeData();

    this.dynamicFindLocationsProxy = this.locationContent.locationsMenuLocationsProximity;
    this.textDirection = contentService.TextDirection();
    // Called before use can make selection to checkboxes.
    // This will set default filters which may change based on the URL client
    this.setFilters();
    this.mapLocations = await this.getLocations();
    this.toggleOffSpinner();
    this.updatedData++;
    this.toggleFilterMenu();
    this.showPageLoader = false
  }

  get autocompleteOptions(): any {
    return {
      componentRestrictions: {
        country: ["US"],
      },
      types: ["geocode"]
    };
  }

  getContentDescription(locationType: string, key: string) {
    if (
      this.locationContent &&
      (this.locationContent as any)[locationType] &&
      (this.locationContent as any)[locationType][key]
    ) {
      return (this.locationContent as any)[locationType][key];
    }
    return "";
  }
  toggleOffSpinner() {
    const submit: HTMLElement | null = document.getElementById("submitFilter");
    const toggle: HTMLElement | null = document.getElementById("filter-toggle");
    submit?.classList.remove("is-loading");
    toggle?.classList.remove("is-loading");
  }

  showApiErrorMessage(titleMessage: string, bodyMessage: string): void {
    Swal.fire({
      title: titleMessage,
      text: bodyMessage,
    });
  }

  showLocationsErrorMessage(titleMessage: string, bodyMessage: string): void {
    Swal.fire({
      html: "<p><b>" + titleMessage + "</b></P>" + "<p>" + bodyMessage + "</p>",
    });
  }

  toggleOnSpinner() {
    const submit: HTMLElement | null = document.getElementById("submitFilter");
    const toggle: HTMLElement | null = document.getElementById("filter-toggle");
    submit?.classList.add("is-loading");
    toggle?.classList.add("is-loading");
  }

  modalLaunch(content: { [key: string]: any }) {
    this.modalHeader = content["modalInfoHeader"];
    this.modalBody = content["modalInfoBody"];
    this.modalLearnMoreLink = content["learnMoreLink"];

    const modal: HTMLElement | null = document.getElementById("modal");
    modal?.classList.add("is-active");
    modal?.classList.add("is-clipped");
  }

  modalClose() {
    const modal: HTMLElement | null = document.getElementById("modal");
    modal?.classList.remove("is-active");
    modal?.classList.remove("is-clipped");
  }

  /**
   * Toggle the filter button and menu based on a filter button click.
   * Defaults to filter button being visible.
   */
  toggleFilterMenu() {
    this.hideFilterMenu = !this.hideFilterMenu;
    const filterBox: HTMLElement | null =
      document.getElementById("container-filter");
    const filterContainerClose: HTMLElement | null = document.getElementById(
      "container-filter-close"
    );
    const filterButton: HTMLElement | null =
      document.getElementById("filter-toggle");
    if (filterBox && filterButton && filterContainerClose) {
      if (
        filterBox?.style.display === "none" ||
        filterBox?.style.display === ""
      ) {
        filterBox.style.display = "flex";
        filterContainerClose.style.display = "flex";
        filterButton.style.display = "none";
      } else {
        filterBox.style.display = "none";
        filterContainerClose.style.display = "none";
        filterButton.style.display = "flex";
      }
    }
  }

  /**
   * sets the filters in the mapData object.
   * The filters are used within the GoogleMap component to hide and show locations.
   */
  setFilters() {
    this.mapData = {};
    this.mapData.filters = [];
    this.mapData.client = this.client;

    if (this.addressInput) {
      this.mapData.addressInput = this.addressInput;
      this.mapData.numMiles = this.numMiles;
      this.mapData.addressLat = this.addressLat;
      this.mapData.addressLng = this.addressLng;
    }
    if (this.earlyheadstartChecked || this.isDHS) {
      this.mapData.filters.push(this.locationContent.earlyHeadStart.keyValue);
    }
    if (this.headstartChecked || this.isDHS) {
      this.mapData.filters.push(this.locationContent.headStart.keyValue);
    }
    if (this.greatstartChecked) {
      this.mapData.filters.push(this.locationContent.greatStart.keyValue);
    }
    if (this.miChildDevChecked) {
      this.mapData.filters.push(this.locationContent.miChildDev.keyValue);
    }
    // Star rating filter is always applied;
    this.mapData.publishedrating = this.sliderStarRating;
  }

  @Watch("sliderRadius")
  onPropertyChanged(value: string) {
    this.dynamicFindLocationsProxy =
      this.locationContent.locationsMenuLocationsProximity.replace("5", value);
    //console.log(value)
  }
  /**
   * Submit the selected filters and toggle the filter menu off.
   */
  async submitData() {
    if ( this.$v.$invalid) {
        return;
    }
    this.setFilters();
    this.toggleFilterMenu();
    try {
        this.mapLocations = await this.getLocations();
    } catch (error) {
        this.showApiErrorMessage(
        this.locationContent.errorMessageApiCallTitle,
        this.locationContent.errorMessageApiCallBody
        );
    }
    this.updatedData++;
  }

  async onAddressBlur(event: any) {
    const textboxValue = event.currentTarget?.value; 
    this.addressSuggestion = textboxValue;
    //this.addressInput = textboxValue;
    this.addressIsComplete = false;
  }

  /**
   * Set address, latitude anad longitude from the google suggestions.
   */
 async setAddress(place: any) {
    [this.addressComponents, this.addressIsComplete] = this.GooglePlaceToAddress(place);
    this.validCounty = false
    this.addressIsComplete = false
    if (this.addressComponents != null) {
        if ( this.addressComponents.address != null) {
            // If we have no county information but we have a zip code, get the county from the zip code data
            if ( this.addressComponents.county === "") {
                this.addressComponents.county = this.zipCodeToCounty(this.addressComponents.zipcode, this.zipCodeData) ?? "";
            } 

            this.addressInput = this.addressComponents.address;
            this.addressLat = this.addressComponents.latitude;
            this.addressLng = this.addressComponents.longitude;
            this.validCounty = this.isValidCounty(this.addressComponents.county);
            this.addressIsComplete = true
        } else {
            this.addressInput = place.name;
        }
    } 
    this.addressSuggestion = this.addressInput;
  }

  /*

  async setAddressFromZipCode(place: any) {
    const possibleZip = place.name.trim();
    const foo = await this.searchAddress(possibleZip);
    // See if the user has entered a zip code

    /*
    if (place.name != null) {
         this.addressInput = place.name;
        // See if the user has entered a zip code
        const possibleCounty = place.name.trim();
        const countyData = this.findZipCodeData(possibleCounty, this.zipCodeData);
        if ( countyData != null) {

             this.addressComponents = {
                county: countyData.county,
                latitude: countyData.latitude,
                longitude: countyData.longitude,
                address: countyData.zipcode,
                zipcode: countyData.zipcode,
                streetaddress: "",
                city: "",
                state: "",
             };

            this.addressLat = countyData.latitude
            this.addressLng = countyData.longitude
            this.validCounty = this.isValidCounty(this.addressComponents.county);
            this.addressIsComplete = this.validCounty
        }
    }
  }
        */

  async clearFilter() {
    this.addressInput = "";
    this.addressSuggestion = this.addressInput;
    this.addressIsComplete = false
    this.addressLat = null;
    this.addressLng = null;
    this.validCounty = false;
    this.earlyheadstartChecked = false;
    this.headstartChecked = false;
    this.greatstartChecked = false;
    this.cooperativeChecked = false;
    this.miChildDevChecked = false;
    this.sliderStarRating = this.sliderDefault;
    this.mapData = {};
    this.setFilters();
    if (this.locationsAll.length) {
      this.mapLocations = this.locationsAll;
    } else {
      this.mapLocations = await this.getLocations();
    }
    this.updatedData++;
  }

  async getLocations() {
    // Only called when an address is set
    // If user adds an address filter make API call every time.
    // Otherwise, save locationsAll to prevent multiple calls that would return all locations.
    if (this.addressLat && this.addressLng) {
      if (!this.isValidCounty) {
        this.showLocationsErrorMessage(
          this.locationContent.errorMessageFilterLocationsTitle,
          this.locationContent.errorMessageFilterLocationsBody
        );
        return this.locationsAll;
      }

      this.center = {
        lat: this.addressLat,
        lng: this.addressLng,
      };

      try {
        this.toggleOnSpinner();
        const locationsNearLtLg =
          await LocationService.getLocationsByLatLonMiles(
            this.addressLat,
            this.addressLng,
            this.sliderRadius
          );
        this.toggleOffSpinner();
        return locationsNearLtLg;
      } catch (error) {
        this.toggleOffSpinner();
        this.showApiErrorMessage(
          this.locationContent.errorMessageApiCallTitle,
          this.locationContent.errorMessageApiCallBody
        );
      }
    }
    // Initial call for locations
    // Only called once. Filters are done on all locations.
    if (!this.locationsAll.length) {
      try {
        this.toggleOnSpinner();
        this.locationsAll = await LocationService.getActive();
        this.toggleOffSpinner();
        if (!this.locationsAll || this.locationsAll.length === 0) {
          this.showApiErrorMessage(
            this.locationContent.errorMessageApiCallTitle,
            this.locationContent.errorMessageApiCallBody
          );
        }
      } catch (error) {
        this.toggleOffSpinner();
        this.showApiErrorMessage(
          this.locationContent.errorMessageApiCallTitle,
          this.locationContent.errorMessageApiCallBody
        );
      }
    }
    return this.locationsAll;
  }
}
